<template>
	<sc-table-select
		ref="tableselect"
		v-model="goodsvalue"
		:attrList="attrList"
		:valueList="valueList"
		:queryList="queryList"
		:orderList="orderList"
		:table-width="640"
		clearable
		collapse-tags
		collapse-tags-tooltip
		:props="props"
		@change="change"
	>
		<template #header="{}">
			<el-form :inline="true">
				<el-row :gutter="5"
					><el-col :span="5">
						<el-input
							v-model="queryList.Code"
							placeholder="请输入物品编码"
							style="width: 125px"
						></el-input></el-col
					><el-col :span="5">
						<el-input
							v-model="queryList.Name"
							placeholder="请输入物品名称"
							style="width: 125px"
						></el-input> </el-col
					><el-col :span="5"
						><el-select
							v-model="queryList.TypeCode"
							placeholder="请选择物品类型"
							style="width: 125px"
							clearable
							:teleported="false"
						>
							<el-option
								label="---请选择---"
								value=""
							></el-option>
							<el-option label="直营店" value="01"></el-option>
							<el-option
								label="加盟店"
								value="02"
							></el-option> </el-select></el-col
					><el-col :span="5">
						<el-select
							v-model="queryList.State"
							placeholder="请选择机构状态"
							clearable
							:teleported="false"
							style="width: 125px"
						>
							<el-option
								label="---请选择---"
								value=""
							></el-option>
							<el-option label="直营店" value="01"></el-option>
							<el-option
								label="加盟店"
								value="02"
							></el-option> </el-select></el-col
					><el-col :span="4">
						<el-button
							type="primary"
							@click="$refs.tableselect.getData()"
							>查询</el-button
						></el-col
					></el-row
				>
			</el-form>
		</template>
		<el-table-column
			prop="GoodsCode"
			label="机构编码"
			width="100"
		></el-table-column>
		<el-table-column
			prop="GoodsName"
			label="机构名称"
			width="180"
		></el-table-column>
		<el-table-column
			prop="GoodsType"
			label="单位"
			width="120"
			:formatter="formatType"
		></el-table-column>
		<el-table-column
			prop="GoodsType"
			label="类型"
			width="120"
			:formatter="formatType"
		></el-table-column>
		<el-table-column
			prop="State"
			label="状态"
			width="100"
		></el-table-column>
	</sc-table-select>
</template>

<script>
export default {
	name: "goodsSelect",
	data() {
		return {
			attrList: {
				Name: "NHubTestGoods",
				UseDistinct: false,
				OrgCode: "",
				UseBackUp: false,
				UseGroup: false,
			},
			valueList: {
				Code: "GoodsCode",
				Name: "GoodsName",
				UomCode:"UomCode",
				GoodsType: "GoodsType",
				State: "State",
			},
			queryList: {
				Code: "",
				Name: "",
				GoodsType: "",
				State: "",
			},
			//apiObj: this.$API.demo.page,
			params: {
				name: "demoName",
			},
			orgcodevalue: [],
			formatType(row, column) {
				
				//////debugger;
				console.log(row, column);
				switch (row.TypeCode) {
					case "01":
						return "直营店";
					case "02":
						return "加盟店";
					default:
						return "";
				}
			},
		};
	},
	computed: {},
	mounted() {},
	// methods: {
	// 	//值变化
	// 	change(val) {
	// 		this.$message("change事件，返回详情查看控制台1");
	// 		console.log(val);
	// 	},
	// },
};
</script>

<style scoped></style>
